import { Component, Inject, OnInit } from '@angular/core';
import { inject } from '@angular/core/testing';
import { MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'dialog-template',
  templateUrl: './dialog-template.component.html',
  styleUrl: './dialog-template.component.css',
  standalone: false
})
export class DialogTemplateComponent {

  constructor(public dialogRef: MatDialogRef<DialogTemplateComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
  }
  onCancelUserDialog(): void {
    this.dialogRef.close();
  }

}
export enum ModalType {
  INFO = 'info',
  WARN = 'warn',
  ERROR = 'error',
  QUESTION = 'question'
}
